import { render, staticRenderFns } from "./Galery.vue?vue&type=template&id=ac375862&scoped=true&"
import script from "./Galery.vue?vue&type=script&lang=js&"
export * from "./Galery.vue?vue&type=script&lang=js&"
import style0 from "./Galery.vue?vue&type=style&index=0&id=ac375862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac375862",
  null
  
)

export default component.exports